import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PluginComponent } from '../plugin.component';
import { Inspection } from '../../shared/models/index';
import { BasePlugin } from '../base-plugin.component';

@Component({
    templateUrl: './peripheralinfo.component.html',
    standalone: false
})
export class PeripheralInfoPluginComponent extends BasePlugin implements OnInit {
  public plugin: any = {};
  inspectionId: string;
  public peripheralInfos: any;
  public inspection: Inspection;

  constructor(private route: ActivatedRoute, private cdRef: ChangeDetectorRef) {
    super();
  }

  ngOnInit() {}

  config(
    plugin: any,
    inspection: Inspection,
    messages: Array<string>,
    showBreadcrumbs: boolean,
    showValidations: boolean,
    showContent: boolean
  ): void {
    super.config(plugin, inspection, messages, showBreadcrumbs, showValidations, showContent);
    this.initData();
    this.peripheralInfos = this.plugin.config.PeripheralInfos.filter((p) => p.Name || p.Number);
    this.cdRef.detectChanges();
  }

  initData() {}

  getEditRoute() {
    return [this.inspectionsRoute, this.inspection.id, 'plugins', this.plugin.id, 'peripheralinfo', 'edit'];
  }
}

PluginComponent.plugins['peripheralinfo'] = PeripheralInfoPluginComponent;
